import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ClassSelector from '../components/ClassSelector';
import MenuShell from '../components/MenuShell';
import ProgressSection from '../components/ProgressSection';
import { useInstructorCourseId } from '../features/instructor/useInstructorCourseId';
import type { StudentProgress } from '../features/progress/progressApi';

/**
 * Instructor-facing class roster. Resolves its own course UUID instead of depending on a route
 * param: it prefers the instructor's saved class, then an active challenge, then their first class.
 */
function InstructorRosterPage() {
  const { t } = useTranslation();
  const { courseId, courses, errorMessage, selectCourse } = useInstructorCourseId();
  const [selectedStudent, setSelectedStudent] = useState<StudentProgress | null>(null);

  function handleSelectCourse(selectedCourseId: string) {
    selectCourse(selectedCourseId);
    setSelectedStudent(null);
  }

  return (
    <>
      <MenuShell courseId={courseId ?? ''} />
      <main
        style={{
          maxWidth: 960,
          margin: '3rem auto',
          padding: '0 1rem',
          display: 'grid',
          gap: '2rem',
        }}
      >
        <h1>Classe</h1>
        {errorMessage && <p role="alert">{errorMessage}</p>}
        {courseId && (
          <>
            <ClassSelector
              courses={courses}
              selectedCourseId={courseId}
              onChange={handleSelectCourse}
              label={t('instructor.progressClass')}
            />
            <ProgressSection
              key={courseId}
              courseId={courseId}
              selectedStudent={selectedStudent}
              onSelectStudent={setSelectedStudent}
            />
          </>
        )}
      </main>
    </>
  );
}

export default InstructorRosterPage;
